/**
 * Copyright 2025 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

import {
    CSSResultArray,
    html,
    SpectrumElement,
    TemplateResult,
} from '@spectrum-web-components/base';
import { property } from '@spectrum-web-components/base/src/decorators.js';

import styles from './underlay.css.js';

/**
 * @element sp-underlay
 *
 * @fires close - When the underlay is "clicked" and the consuming pattern should chose whether to close based on that interaction
 */
export class Underlay extends SpectrumElement {
    public static override get styles(): CSSResultArray {
        return [styles];
    }

    private canClick = false;

    @property({ type: Boolean, reflect: true })
    public open = false;

    public override click(): void {
        this.dispatchEvent(new Event('close'));
    }

    protected handlePointerdown(): void {
        this.canClick = true;
    }

    protected handlePointerup(): void {
        if (this.canClick) {
            this.click();
        }
        this.canClick = false;
    }

    protected override render(): TemplateResult {
        return html``;
    }

    protected override firstUpdated(): void {
        this.addEventListener('pointerdown', this.handlePointerdown);
        this.addEventListener('pointerup', this.handlePointerup);
    }
}
